import React from 'react';
import { Icon, SemanticICONS } from 'semantic-ui-react';
import { LineMetricByTypeDto } from '../../../services/dashboard/dashboardService';
import GlassmorphismTheme from '../../../styles/glassmorphism';

interface LineMetricCardProps {
  title: string;
  icon: SemanticICONS;
  color: string;
  metric: LineMetricByTypeDto;
  tooltip?: string;
}

const LineMetricCard: React.FC<LineMetricCardProps> = ({ title, icon, color, metric, tooltip }) => {
  return (
    <div
      style={{
        ...GlassmorphismTheme.components.glassCard,
        padding: GlassmorphismTheme.spacing.md,
        border: `1px solid ${color}33`,
        background: '#ffffff',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        transition: GlassmorphismTheme.transitions.normal,
        height: '100%',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
        (e.currentTarget as HTMLElement).style.boxShadow = `0 12px 40px ${color}33`;
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
        (e.currentTarget as HTMLElement).style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
      }}
      title={tooltip}
    >
      {/* Header com total */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px', 
        marginBottom: GlassmorphismTheme.spacing.sm 
      }}>
        <Icon 
          name={icon} 
          size="large"
          style={{
            color: color,
            filter: 'drop-shadow(0 4px 8px rgba(176, 196, 222, 0.2))'
          }}
        />
        <h4 style={{
          margin: 0,
          color: GlassmorphismTheme.colors.solid.textLight,
          fontSize: '0.8rem',
          fontWeight: 500,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          flex: 1
        }}>
          {title}
        </h4>
        <div style={{
          fontSize: '2rem',
          fontWeight: 700,
          color: color,
          lineHeight: 1
        }}>
          {metric.total.toLocaleString('pt-BR')}
        </div>
      </div>

      {/* Separação por tipo — layout horizontal compacto */}
      <div style={{
        display: 'flex',
        gap: '8px',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        paddingTop: GlassmorphismTheme.spacing.sm,
        marginTop: GlassmorphismTheme.spacing.sm
      }}>
        <TypeBadge label="Aditivo" value={metric.aditivo} color="#3498db" />
        <TypeBadge label="Renegociação" value={metric.renegociacao} color="#f39c12" />
      </div>
    </div>
  );
};

const TypeBadge: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
  <div style={{
    flex: 1,
    textAlign: 'center',
    padding: '6px 0',
    borderRadius: '6px',
    background: 'rgba(255, 255, 255, 0.04)',
  }}>
    <div style={{ 
      fontSize: '1.1rem', 
      fontWeight: 600, 
      color,
      lineHeight: 1,
      marginBottom: '2px'
    }}>
      {value.toLocaleString('pt-BR')}
    </div>
    <div style={{
      fontSize: '0.7rem',
      color: GlassmorphismTheme.colors.solid.textLight,
      opacity: 0.6,
    }}>
      {label}
    </div>
  </div>
);

export default LineMetricCard;

